module.exports = __webpack_public_path__ + "img/2.864d1a69.png";